<template>
  <react-wrapper :component="subjectDoesNotExist" :style="{ height: '100%' }" />
</template>

<script lang="ts">
import SubjectDoesNotExist from '@/react-components/pages/subject-does-not-exist'

export default {
  computed: {
    subjectDoesNotExist() {
      return SubjectDoesNotExist
    },
  },
}
</script>
